/**
 * Strandningsmeddelande enligt 18 § hyresförhandlingslagen (1978:304).
 *
 * The landlord's notice that a negotiation has failed and that it is
 * withdrawing from it. A one-block letter, not a numbered agreement — its
 * heading is a section with `numbering: 'none'`, so it anchors and can be
 * referenced without claiming a point number.
 *
 * Sequel to a förhandlingsframställan: it cites that request's date. Signed
 * by the landlord alone and delivered by registered post — never routed to
 * an e-signing provider.
 *
 * Legal text verbatim from `base-templates/STRANDNINGSMEDDELANDE.docx`.
 */
import { group, nodes, p, section, t } from '@hyranai/regta-document-ir';
import { dateVal, fieldRows, partySlot, propertySlot, textVal } from '../common/index.js';
const LEGAL = {
    plane: 'legal',
    status: 'published',
    language: 'sv-SE',
    legalReview: { reviewedBy: 'Haymanot', source: 'base-templates/STRANDNINGSMEDDELANDE.docx' },
};
export const mottagare = {
    ...LEGAL,
    blockKey: 'strandning.mottagare',
    version: 'v1',
    title: 'Till',
    summary: 'Date line and the recipient tenant organisation.',
    slots: [
        { key: 'request_date', label: 'Datum', type: 'date', required: true, statutory: true },
        partySlot('tenant_org_name', 'Hyresgästorganisation', 'other', 0, 'name', { required: true, statutory: true }),
    ],
    compile: (input, ctx) => nodes(fieldRows([
        ['Datum', [dateVal(ctx, input, 'request_date')]],
        ['Till', [textVal(input, 'tenant_org_name')]],
    ])),
};
export const strandning = {
    ...LEGAL,
    blockKey: 'strandning.strandning',
    version: 'v1',
    title: 'Strandning av förhandling',
    summary: 'The operative notice: negotiations reached no agreement, and the landlord withdraws under 18 § HFL.',
    slots: [
        propertySlot('property_designation', 'Fastighet(er)', 'designation', { type: 'textarea', required: true, statutory: true }),
        propertySlot('property_address', 'Adress(er)', 'address', { type: 'textarea', required: true, statutory: true }),
        {
            key: 'framstallning_date',
            label: 'Förhandlingsframställning per den',
            type: 'date',
            required: true,
            statutory: true,
            help: 'Datum för den förhandlingsframställning som förhandlingen avsåg.',
        },
    ],
    compile: (input, ctx) => [
        section('strandning', 'Strandning av förhandling', [
            p('Parterna har förhandlat enligt hyresförhandlingslagen beträffande:'),
            group(nodes(fieldRows([
                ['Fastighet(er)', [textVal(input, 'property_designation')]],
                ['Adress(er)', [textVal(input, 'property_address')]],
            ])), { variant: 'boxed' }),
            p([t('Avseende förhandlingsframställning per den '), dateVal(ctx, input, 'framstallning_date'), t('.')]),
            p('Trots genomförda förhandlingar har parterna inte kunnat nå en överenskommelse. Hyresvärden frånträder därför förhandlingarna enligt 18 § hyresförhandlingslagen från och med dagens datum.'),
        ], { numbering: 'none' }),
    ],
};
export const STRANDNING_BLOCKS = [mottagare, strandning];
//# sourceMappingURL=blocks.js.map